import {
    Control,
    FieldArrayWithId,
    UseFieldArrayRemove,
} from 'react-hook-form';
import { DndContext, closestCenter, DragEndEvent } from '@dnd-kit/core';
import {
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { SensorDescriptor, SensorOptions } from '@dnd-kit/core/dist/sensors';
import SortableQuestion from '../SortableQuestion';
import {
    IApplyNowAdditionalQuestionsForm,
    IApplyQuestion,
    IJobQuestionsForm,
    ISaveJobForm,
    QuestionMode,
} from '../../../../../common';
import { Box, useTheme } from '../../../../../base';
import { QuestionAnswerField } from './QuestionAnswerField';

interface QuestionsListProps {
    fields?: FieldArrayWithId<IJobQuestionsForm, 'questions', 'id'>[];
    applyQuestions?: IApplyQuestion[];
    control:
        | Control<IJobQuestionsForm>
        | Control<IApplyNowAdditionalQuestionsForm>
        | Control<ISaveJobForm>;
    remove?: UseFieldArrayRemove;
    sensors?: SensorDescriptor<SensorOptions>[];
    onDragEnd?: (event: DragEndEvent) => void;
    mode?: QuestionMode;
    showDealbreakerInfo?: boolean;
}

export const QuestionsList = ({
    fields = [],
    control,
    remove,
    sensors,
    onDragEnd,
    mode = QuestionMode.SUBMIT,
    applyQuestions = [],
    showDealbreakerInfo = false,
}: QuestionsListProps) => {
    const theme = useTheme();

    if (mode === QuestionMode.VIEW || mode === QuestionMode.SUBMIT) {
        return (
            <Box
                sx={{
                    '& > *': {
                        borderBottom: `1px solid ${theme.palette.divider}`,
                    },
                    '& > *:last-child': {
                        borderBottom: 'none',
                    },
                }}
            >
                {applyQuestions.map((question, index) => (
                    <QuestionAnswerField
                        key={question.id}
                        question={question}
                        disabled={mode === QuestionMode.VIEW}
                        control={
                            control as Control<IApplyNowAdditionalQuestionsForm>
                        }
                        index={index}
                        showDealbreakerInfo={showDealbreakerInfo}
                    />
                ))}
            </Box>
        );
    }

    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={onDragEnd}
        >
            <SortableContext
                items={fields.map((field) => field.id)}
                strategy={verticalListSortingStrategy}
            >
                {fields.map(
                    (
                        field: FieldArrayWithId<
                            IJobQuestionsForm,
                            'questions',
                            'id'
                        >,
                        index: number
                    ) => {
                        return (
                            <SortableQuestion
                                key={field.id}
                                fieldId={field.id}
                                index={index}
                                control={
                                    control as Control<IJobQuestionsForm>
                                }
                                remove={remove!}
                            />
                        );
                    }
                )}
            </SortableContext>
        </DndContext>
    );
};
